// Hardcoded puzzle data for testing
// This will later be replaced with an API call or daily puzzle generation

import { PipsPuzzle, Difficulty } from "./constants";

export const PUZZLES: Record<Difficulty, PipsPuzzle> = {
  easy: {
    difficulty: "easy",
    dominoes: [
      // Add your dominoes here [value1, value2]
      [0, 4],
      [3, 4],
      [1, 2],
      [1, 6],
    ],
    board: {
      width: 3,
      height: 5,
      layout: [
        // Add your layout here - use region letters (A, B, C), " " for spaces, "" for empty
        ["A", "A", ""],
        ["A", "B", "B"],
        ["C", "", ""],
        ["C", "", ""],
        [" ", "", ""],
      ],
    },
    regions: {
      // Define your regions here
      // A: { color: "#e3f2fd", condition: { type: "sum", value: 0 } },
      A: { color: "#e3f2fd", condition: { type: "sum", value: 7 } },
      B: { color: "#f3e5f5", condition: { type: "sum", value: 7 } },
      C: { color: "#fff9c4", condition: { type: "sum", value: 6 } },
    },
  },

  medium: {
    difficulty: "medium",
    dominoes: [
      // Add your dominoes here [value1, value2]
      [0, 2],
      [2, 4],
      [1, 5],
      [0, 0],
      [4, 4],
      [1, 2],
      [3, 5],
    ],
    board: {
      width: 6,
      height: 6,
      layout: [
        // Add your layout here - use region letters (A, B, C), " " for spaces, "" for empty
        ["A", "A", "", "", "", ""],
        ["B", "A", "C", "", "E", "E"],
        ["", "", "D", "D", "E", ""],
        ["", "", "", "D", "", ""],
        ["", "", " ", "D", "", ""],
        ["", "", " ", "", "", ""],
      ],
    },
    regions: {
      // Define your regions here
      // A: { color: "#e3f2fd", condition: { type: "sum", value: 0 } },
      A: { color: "#e3f2fd", condition: { type: "less-than", value: 9 } },
      B: { color: "#f3e555", condition: { type: "sum", value: 4 } },
      C: { color: "#fff9c4", condition: { type: "sum", value: 2 } },
      D: { color: "#fce4ec", condition: { type: "sum", value: 8 } },
      E: { color: "#e8f5e9", condition: { type: "not-equal" } },
    },
  },

  hard: {
    difficulty: "hard",
    dominoes: [
      // Add your dominoes here [value1, value2]
      [0, 1],
      [2, 3],
      [5, 5],
      [3, 5],
      [0, 3],
      [6, 6],
      [0, 5],
      [1, 4],
      [2, 2],
    ],
    board: {
      width: 5,
      height: 6,
      layout: [
        // Add your layout here - use region letters (A, B, C), " " for spaces, "" for empty
        ["", "", "A", "B", ""],
        ["", "", "B", "B", ""],
        ["C", "C", "C", "B", "G"],
        ["D", "C", "F", "F", "G"],
        ["", "E", "E", "", ""],
        ["", "E", "E", "", ""],
      ],
    },
    regions: {
      // Define your regions here
      // A: { color: "#e3f2fd", condition: { type: "sum", value: 0 } },
      A: { color: "#e3f2fd", condition: { type: "sum", value: 6 } },
      B: { color: "#f3e5f5", condition: { type: "sum", value: 19 } },
      C: { color: "#fff9c4", condition: { type: "sum", value: 5 } },
      D: { color: "#fce4ec", condition: { type: "sum", value: 4 } },
      E: { color: "#e8f5e9", condition: { type: "sum", value: 9 } },
      F: { color: "#fff3e0", condition: { type: "sum", value: 3 } },
      G: { color: "#e1f5fe", condition: { type: "not-equal" } },
    },
  },
};

// ========== COMMENTED OUT PREVIOUS PUZZLES ==========
// export const PUZZLES: Record<Difficulty, PipsPuzzle> = {
//   easy: {
//     difficulty: "easy",
//     dominoes: [
//       [3, 5],
//       [0, 1],
//       [4, 4],
//       [6, 6],
//     ], // 4 dominoes
//     board: {
//       width: 5,
//       height: 3,
//       layout: [
//         ["A", "A", "", "", ""],
//         ["", " ", "B", "C", " "],
//         ["", "", "B", "C", ""], // Empty corners
//       ],
//     },
//     regions: {
//       A: {
//         color: "#e3f2fd", // Light blue
//         condition: { type: "sum", value: 8 }, // Can be: 1+1+3 or 2+2+1
//       },
//       B: {
//         color: "#f3e5f5", // Light purple
//         condition: { type: "sum", value: 7 }, // Can be: 2+2+2 or 3+3+3
//       },
//       C: {
//         color: "#fff9c4", // Light yellow
//         condition: { type: "sum", value: 5 }, // Can be: 1+4 or 2+3
//       },
//     },
//   },
//
//   medium: {
//     difficulty: "medium",
//     dominoes: [
//       [5, 5],
//       [0, 1],
//       [4, 5],
//       [1, 2],
//       [2, 3],
//       [2, 5],
//       [6, 6],
//     ], // 10 dominoes
//     board: {
//       width: 4,
//       height: 5,
//       layout: [
//         ["A", "A", "", ""],
//         [" ", "A", "B", " "],
//         [" ", "C", "B", " "],
//         ["", "C", "C", ""],
//         ["", "D", "D", ""],
//       ],
//     },
//     regions: {
//       A: { color: "#e3f2fd", condition: { type: "sum", value: 9 } },
//       B: { color: "#f3e5f5", condition: { type: "equal" } },
//       C: { color: "#fff9c4", condition: { type: "sum", value: 16 } },
//       D: { color: "#fce4ec", condition: { type: "sum", value: 8 } },
//     },
//   },
//
//   hard: {
//     difficulty: "hard",
//     dominoes: [
//       [1, 4],
//       [1, 3],
//       [3, 4],
//       [2, 6],
//       [3, 4],
//       [0, 1],
//       [0, 4],
//       [5, 6],
//       [4, 4],
//     ], // 10 dominoes
//     board: {
//       width: 8,
//       height: 5,
//       layout: [
//         ["", "", "C", "C", "", "", "", ""],
//         ["A", "B", "C", "", "", "", "", ""],
//         ["A", "B", "C", "D", "D", "D", "E", ""],
//         ["", "", "", "", "", "E", "E", "F"],
//         ["", "", "", "", "", "G", "F", "F"],
//       ],
//     },
//     regions: {
//       A: { color: "#e3f2fd", condition: { type: "equal" } },
//       B: { color: "#f3e5f5", condition: { type: "greater-than", value: 5 } },
//       C: { color: "#fff9c4", condition: { type: "less-than", value: 13 } },
//       D: { color: "#fce4ec", condition: { type: "sum", value: 13 } },
//       E: { color: "#e8f5e9", condition: { type: "less-than", value: 10 } },
//       F: { color: "#fff3e0", condition: { type: "not-equal" } },
//       G: { color: "#e1f5fe", condition: { type: "sum", value: 3 } },
//     },
//   },
// };

// Future: This function will calculate which puzzle to show based on the date
export function getTodaysPuzzle(difficulty: Difficulty): PipsPuzzle {
  // For now, just return the hardcoded puzzle
  return PUZZLES[difficulty];

  // Future implementation:
  // const today = new Date();
  // const startDate = new Date('2024-11-01');
  // const daysSinceStart = Math.floor((today - startDate) / (1000 * 60 * 60 * 24));
  // return fetchPuzzleForDay(daysSinceStart, difficulty);
}

// Helper function to get a specific puzzle (useful for testing)
export function getPuzzle(difficulty: Difficulty): PipsPuzzle {
  return PUZZLES[difficulty];
}
